import { InterviewDTO } from "../../../models/recruiting/interviews/interview-dto";
import { InterviewSTO } from "../../../models/recruiting/interviews/interview-sto";
import { BaseApiService } from "../../base/base-api.service";

export class InterviewsApiService extends BaseApiService<InterviewDTO, InterviewSTO> {
  constructor() {
    super({
      servicePath: "/Interviews",
      loadItemsPath: "/GetInterviews",
      saveItemsPath: "/SaveInterviews",
    });
  }
}
